export default "__VITE_ASSET__DqEnE$J1__"